import { useContext, useEffect } from 'react';
import QAContext from '../../context/QAContext';
import { DEFAULT_NUMBER_OF_PAGES, QUESTION_DISPLAY_PER_PAGE } from '../../constants';
import { getDesktopPage2StartIndex, getNextPage, getPrevPage } from '../../helpers/QAHelper';

export const useSEO = (qaResult) => {
  const { channel, dispatch, seoPageNumber, enableExperienceProperty } = useContext(QAContext);

  const isMobile = channel === 'mobile';
  const desktopPage2StartIndex = getDesktopPage2StartIndex(enableExperienceProperty);
  useEffect(() => {
    if (seoPageNumber) {
      dispatch({ action: 'SET_CURRENT_PAGE', value: seoPageNumber });

      if (seoPageNumber === DEFAULT_NUMBER_OF_PAGES) {
        dispatch({ action: 'SET_START_INDEX', value: DEFAULT_NUMBER_OF_PAGES });
      } else {
        const newStartIndex = !isMobile ? desktopPage2StartIndex + (seoPageNumber - 2) * QUESTION_DISPLAY_PER_PAGE
          : QUESTION_DISPLAY_PER_PAGE * (seoPageNumber - DEFAULT_NUMBER_OF_PAGES) + DEFAULT_NUMBER_OF_PAGES;
        dispatch({ action: 'SET_START_INDEX', value: newStartIndex });
      }
    }
  }, []);

  return {
    seoResults: qaResult?.data?.Results,
    seoAnswers: qaResult?.data?.Answers,
    seoTotalResults: qaResult?.data?.TotalResults,
    seoPrevPage: getPrevPage(qaResult?.data?.TotalResults, qaResult?.data?.Offset, qaResult?.data?.Limit),
    seoNextPage: getNextPage(qaResult?.data?.TotalResults, qaResult?.data?.Offset, qaResult?.data?.Limit)
  };
};
